/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Grid, Tooltip, Typography, Divider, IconButton, Backdrop, Avatar, Paper, Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button } from '@material-ui/core'

import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../tableIcons";
import HighlightOff from "@material-ui/icons/HighlightOff";

import CheckCircleOutlined from "@material-ui/icons/CheckCircleOutlined";
import AutorenewTwoToneIcon from "@material-ui/icons/AutorenewTwoTone";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import Add from "@material-ui/icons/Add";
import Refresh from "@material-ui/icons/Refresh";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import ScheduleIcon from '@material-ui/icons/Schedule';
import Cancel from "@material-ui/icons/Cancel";
import Visibility from "@material-ui/icons/Visibility"
import EditOutlined from "@material-ui/icons/EditOutlined";
import { DeleteConfirmationDialog } from "./../Utilities/DeleteConfirmationDialog";
import ErrorMessageAlert from "../Utilities/ErrorMessageAlert";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartNetwork, faSnooze, faMicrochip, faTrash, faCalendar } from '@fortawesome/pro-duotone-svg-icons'
import Scheduler from '../Scheduler/Scheduler'

import Actions from './../../fluid/Actions/ActionFactory.js'

import Event from '@material-ui/icons/Event'
import { CancelOutlined } from '@material-ui/icons';


import { faHourglassEnd } from "@fortawesome/pro-duotone-svg-icons";

import AddSecurityAdaptor from "../CreateSecurityAdaptor/AddSecurityAdaptor";

import SecureWrapper from "../Security/SecureWrapper";
import { allowedByOpop } from "../Security/SecureCheck";

const clone = require('rfdc')()



const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      // primary: {
      //     main: "#FF6600",
      //     contrastText: "#FFFFFFFF"
      // },
      secondary: {
        main: "#dc004e",
      },
    },
});



const bot_input = [
    {
        "id": 1,
        "name": "bot one"
    }

]

const styles = theme => ({
    '@keyframes pulsate' : {
        from : {
            opacity : 0.25
        },
        to : {
            opacity : 1.0
        }
    },
    active : {
        color : "#4caf50",
        fontSize : '15px'
    },
    running : {
        color : "#4caf50",
        fontSize : '15px',
        animation : '$pulsate 250ms infinite alternate'
    },
    deactive : {
        color : "#FF8C02",
        fontSize : '15px',
        animation : '$pulsate 3000ms infinite alternate'
    },
    backdrop: {
        zIndex: "10",
        color: '#fff',
    },
    "@keyframes spin": {
        from: { transform: "rotate(0deg)" },
        to: { transform: "rotate(360deg)" },
    },
    "@keyframes slide": {
        from: { left: "0px" },
        tp: { right: "30px" },
    },
    in_progress: {
        color: "#039be5",
        textAlign: "center",
        animation: "$spin 2s infinite linear",
    },
    in_progress_dt: {
        color: "#039be5",
        textAlign: "center",
        animation: "$slide 2s infinite linear",
    },
})

class SecurityAdaptorsList extends Component {
    state = {
        isLoading: false,
        data: [],
        adding_security_adaptor: false,
        security_adaptor_name: null,
        editing_security_adaptor: false,
        security_adaptor_details: null,
        deletingItem: {},
        errorOpen: false,
        errorInfo: {},
        confirmDeleteDialogOpen: false,
    }

    componentDidMount () {
        this.getSecurityAdaptors();
    }

    

    getSecurityAdaptors = () => {
        this.setState({ ...this.state, isLoading: true}, () => {
            Actions('http_request', {
                url : "/sainapse/security_adapter",
                method : 'get',
                data : {}
            }).then(res => {
                this.setState({...this.state, data: res.data.result, isLoading: false }, () => {
                    this.setState({ isLoading: false })
                })
            }).catch((err) => {
                console.log(err)
                this.setState({
                    errorOpen: true,
                    errorInfo: err,
                })
            })
        })
    }

    // To add Security Adaptor
    goToCreateSecurityAdaptor = () => {
        this.setState({ adding_security_adaptor: true })
    }

    //Get Security Adaptor Details by name
    getSecurityAdaptorDetails = (security_adaptor_details) => {
        this.setState({ security_adaptor_details: security_adaptor_details, editing_script: true });
    };

    //cancel deletion
    cancelDelete = () => {
        this.setState({ deletingItem: {}, confirmDeleteDialogOpen: false });
    };
    
    //confirm deletion
    confirmDelete = () => {
        this.setState({ confirmDeleteDialogOpen: false });
            Actions("http_request", {
                url: "/sainapse/security_adapter/" + this.state.deletingItem.name,
                method: "delete",
                // data : {}
            })
            .then((res) => {
                this.getSecurityAdaptors();
                this.setState({ deletingItem: {} });
            })
            .catch((err) =>
            this.setState({
                deletingItem: {},
                errorOpen: true,
                errorInfo: err,
            })
        );
    };
    
    //delete
    deleteSecurityAdaptor = (rowData) => {
        this.setState({ deletingItem: rowData, confirmDeleteDialogOpen: true });
    };
    
    //error
    handleErrorClose = () => {
        this.setState({ errorOpen: false, errorInfo: {} });
    };
    
    //close popup close
    handlePopupClose = () => {
        this.setState({ adding_security_adaptor: false, editing_security_adaptor: false }, () => {
            this.getSecurityAdaptors();
        });
    };
    getDisableStatus= (name) => {
    
        return !allowedByOpop({
          operation : "/sainapse/security_adapter/{name}",
          method : "DELETE",
          operands : [
            {
              attrName: "name",
              value : name
        }]
        })
    };

    renderActions = (row_data) => {
        if (
          row_data.name !== this.state.deletingItem.name ||
          this.state.confirmDeleteDialogOpen
        ) {
          return (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* <Tooltip title="Edit" arrow>
                <IconButton
                  size="small"
                  style={{ marginRight: "0px" }}
                  onClick={() => this.getSecurityAdaptorDetails(row_data)}
                >
                  <EditOutlined fontSize="small" />
                </IconButton>
              </Tooltip> */}
              <Tooltip title="Delete" arrow>
                <IconButton
                  size="small"
                  style={{ color: !this.getDisableStatus(row_data.name) ? "#f44336": "rgb(0,0,0,0.3)", marginRight: "0px" }}
                  onClick={() => this.deleteSecurityAdaptor(row_data)}
                  disabled = {this.getDisableStatus(row_data.name)}
                >
                  <DeleteOutline fontSize="small" />
                </IconButton>
              </Tooltip>
            </div>
          );
        } else {
          return <Typography variant="overline">Deleting...</Typography>;
        }
      };

    render() {
        const { classes } = this.props
        return (
            <Fragment>
                <SecureWrapper
                                access_object = {{
                                    operation : "/sainapse/security_adapter",
                                    method : "GET",
                                    operands : []
                                }}
                                shouldRenderErrorMessage = {true}
                                errorMessage = "User does not have sufficient privileges"
                                textVariant = "subtitle2"
                                >
                <MaterialTable
                    tableRef={this.tableRef}
                    style={{width : '100vw', height: "calc(100vh - 48px)" }}
                    title="Security Configuration"
                    icons={table_icons}
                    columns = {[
                        {title : "Name", field : "name", cellStyle : {
                            textAlign : 'left'
                        }},
                        {
                            title: "Description", field: "description", cellStyle: {
                                textAlign: "left"
                            }
                        },
                        // {
                        //     title: "Type",
                        //     field: "key",
                        //     cellStyle: {
                        //         textAlign: "left"
                        //     }
                        // },
                        {
                            title: "Created Date",
                            field: "created_date",
                            type: "datetime",
                        },
                        {
                            title: "Updated Date",
                            field: "updated_date",
                            type: "datetime",
                            defaultSort: "desc",
                        },
                        {title: "Setup Complete", field: "setup_complete", 
                            render: (rowData) => {
                                if (rowData.setup_complete === false) {
                                    return (
                                    <Tooltip title = "Setup is not complete">
                                        <HighlightOff fontSize="small" style={{ color: "#f44336" }} />
                                    </Tooltip>
                                    );
                                } else {
                                    return (
                                        <Tooltip title = "Setup Complete">
                                            <CheckCircleOutlined
                                                fontSize="small"
                                                style={{ color: "#4caf50" }}
                                            />
                                        </Tooltip>
                                    );
                            
                                }
                            }
                        },
                        {
                            title: "Actions",
                            render: (rowData) => {
                                return this.renderActions(rowData)
                            }
                        }
                        
                        
                    ]}
                    data = {this.state.data}
                    
                    options={{
                        search: true,
                        cellStyle: {
                            height: "5vh",
                            paddingTop: 0,
                            paddingBottom: 0,
                        },
                        toolbarButtonAlignment: "right",
                        paging: false,
                        pageSize: 10,
                        pageSizeOptions: [10, 20, 50],
                        headerStyle: {
                        height: "7vh",
                        padding: 0,
                        margin: 0,
                        textAlign: "center",
                        backgroundColor: "#F0F0F0",
                        lineHeight: "1.25",
                        },
                        maxBodyHeight: "78vh",
                        detailPanelType: "single",
                        draggable: false,
                    }}
                    isLoading={this.state.isLoading}
                    components={{
                        Toolbar: (props) => (
                        <Fragment>
                            <MTableToolbar {...props} />
                            <Divider />
                            <div
                            style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row-reverse",
                                height: "5vh",
                                alignContent: "flex-end",
                            }}
                            >
                            <ThemeProvider theme={blue_theme}>
                            <SecureWrapper
                                access_object = {{
                                    operation : "/sainapse/security_adapter",
                                    method : "GET",
                                    operands : []
                                }}
                                >
                                <Tooltip title="Refresh" onClick={this.getSecurityAdaptors}>
                                <IconButton color="primary">
                                    <Refresh />
                                </IconButton>
                                </Tooltip>
                                </SecureWrapper>
                                <SecureWrapper
                                    access_object = {{
                                        operation : "/sainapse/security_adapter",
                                        method : "POST",
                                        operands : []
                                    }}
                                    >
                                <Tooltip title="Add Security Adaptor">
                                    <IconButton
                                        color="primary"
                                        onClick={this.goToCreateSecurityAdaptor}
                                    >
                                    <Add/>
                                </IconButton>
                                </Tooltip>
                                </SecureWrapper>
                            </ThemeProvider>
                            </div>
                            <Divider />
                        </Fragment>
                        ),
                    }}
                />
                </SecureWrapper>

                {
                    this.state.adding_security_adaptor === true && (
                        <Backdrop
                            className={classes.backdrop}
                            style={{ width: "100vw", height: "100vh" }}
                            open={this.state.adding_security_adaptor}
                        >
                            <AddSecurityAdaptor
                                security_adaptor_name={this.state.security_adaptor_name}
                                close={this.handlePopupClose}
                                security_adaptor_details={this.state.security_adaptor_details}
                                edit_mode={false}
                            />
                        </Backdrop>
                )}

                {/* {
                    this.state.editing_security_adaptor === true && (
                        <Backdrop
                            className={classes.backdrop}
                            style={{ width: "100vw", height: "100vh" }}
                            open={this.state.editing_security_adaptor}
                        >
                            <AddSecurityAdaptor
                                security_adaptor_name={this.state.security_adaptor_name}
                                close={this.handlePopupClose}
                                security_adaptor_details={this.state.security_adaptor_details}
                                edit_mode={true}
                            />
                        </Backdrop>
                )} */}
                {this.state.errorOpen ? (
                    <ErrorMessageAlert
                        open={this.state.errorOpen}
                        handleClose={this.handleErrorClose}
                        errorInfo={this.state.errorInfo}
                    ></ErrorMessageAlert>
                ) : null}
       
                    
            <DeleteConfirmationDialog
                open={this.state.confirmDeleteDialogOpen}
                name={this.state.deletingItem.name}
                type={"Security Adaptor"}
                confirmDeleteHandler={this.confirmDelete}
                cancelDeleteHandler={this.cancelDelete}
            ></DeleteConfirmationDialog>
        
        </Fragment>
        );
    }
}

export default withRouter(withStyles(styles)(SecurityAdaptorsList));
